var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex":"1"}},[_c('Select2',{attrs:{"disabled":_vm.disabled,"options":_vm.options.data,"settings":{
      multiple: _vm.options.multiple || false,
      allowClear: _vm.options.allowClear || false,
    }},on:{"change":_vm.onSelect},model:{value:(_vm.modalSchedule),callback:function ($$v) {_vm.modalSchedule=$$v},expression:"modalSchedule"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }